import React from "react";
import PropTypes from "prop-types";
import { FormattedNumber } from "react-intl";
import { getUnit } from "./Units";

const UnitValue = (props) => {
	if (props.value === undefined || props.value === null) {
		return <span>{"---"}</span>;
	}
	let unit = getUnit(props.units[props.unit]);
	let digits = (props.digits === undefined ||
		props.digits === null)
		? unit.digits
		: props.digits;
	return <FormattedNumber
		minimumFractionDigits={digits}
		maximumFractionDigits={digits}
		value={unit.toAnzeige(props.value)}/>;
};

UnitValue.propTypes = {
	digits: PropTypes.number,
	value: PropTypes.number,	/* muss auch undefined sein dürfen (bevor Snapshot hier ankommt) */
	unit: PropTypes.string.isRequired,
	units: PropTypes.object.isRequired
};

export default UnitValue;
